import { Box, ButtonLink, Inline } from 'braid-design-system';
import React from 'react';

import { createNavLinks, navLinkIds } from '../utils/generalUtils';

import { RegisterTextLink, SignInTextLink } from './NavTextLink';

import * as styles from './ProfileActionsLoggedOut.css';

interface ProfileActionsLoggedOutProps {
  baseUrl: string;
}

export const ProfileActionsLoggedOut = ({
  baseUrl,
}: ProfileActionsLoggedOutProps) => {
  const links = createNavLinks(baseUrl);

  return (
    <Box display="flex">
      <Inline space="small" alignY="center">
        <Inline space="xxsmall" alignY="center">
          <SignInTextLink baseUrl={baseUrl} />
          <span className={styles.loginSeparator}>&nbsp;</span>
          <RegisterTextLink baseUrl={baseUrl} />
        </Inline>

        <ButtonLink
          id={navLinkIds.sellABusinessButton}
          href={links.sellABusiness}
          tone="brandAccent"
          data={{ htag: navLinkIds.sellABusinessButton }}
        >
          Sell a business
        </ButtonLink>
      </Inline>
    </Box>
  );
};
